module.exports = __webpack_public_path__ + "img/14.e27cf4fb.png";